// Permission Names

import _ from "lodash";

export const PERMISSION_ID = "permissionId";
export const PERMISSION_GRANTED_REVOKED = "grantedRevoked";

export const GRANTED = "G";
export const REVOKED = "R";

export const Permissions = {
  ACTION_BUTTON: "AM_Actions_Button",
  APPLICATION_PRINT: "AM_Application_Print",
  APPLICATION_DFM_INV_STYLE: "AM_Application_DFM_Inv_Style",

  STATEMENT_VALUATION_CUSTOM_DATE: "AM_Statement_Valuation_Custom_Date_Pdf",
  STATEMENT_VALUATION_PDF: "AM_Statement_Valuation_Pdf",
  STATEMENT_PDF: "AM_StatementPdf",
  VALUATION_PDF: "AM_ValuationPdf",

  CREATE_BESPOKE_PORTFOLIO: "Create_Bespoke_Portfolios",
  DEALING: "Dealing",
  EDIT_CLIENT_DETAILS: "Edit_Client_Details",

  // There are permissions generated from productID in Product.js - getProductPermissionID
  // Which is now used in Application.js
  // e.g. Create_GIA

  // There are permissions generated from productID in Confirmation.js and Summary.js
  // e.g. GA_Application_Print_GIA, GA_Illustration_Print_GIA, GA_Amendment_Print_GIA

  ILLUSTRATION_SHOW_WORKINGS: "GA_Illustration_show_workings",

  PROCESS_APPLICATIONS: "Process_Applications",
  SUBMIT_APPLICATIONS: "Submit_Applications",

  ADVANCED_AMENDMENT_OPTIONS: "Advanced_Amendment_Options",
  ACCOUNT_AMENDMENT_SWITCH: "Account_Amendment_Switch",
  ACCOUNT_AMENDMENT_TOPUP: "Account_Amendment_Topup",
  ACCOUNT_AMENDMENT_CHARGES: "Account_Amendment_Charges",
  ACCOUNT_AMENDMENT_WITHDRAWAL: "Account_Amendment_Withdrawal",
  INVESTMENT_SUBMIT: "AM_Investment_Submit",
  CAPITAL_GAINS_TAX: "AM_Capital_Gains_Tax",
  CREATE_SUB_ACCOUNT: "Create_Sub_Account",

  VIEW_OTHER_CLIENTS: "View_other_clients",
  ALLOCATE_ADVISER: "Ability_to_Allocate_Adviser",
  DASH_EMPLOYEE: "dash_employee",
  DASH_CLIENT: "dash_client",

  EMPLOYEE_EDIT: "employee_edit",
  EMPLOYEE_ROLES: "employee_roles",
  VIEW_EMPLOYEE_PERMISSIONS: "View_Employee_Permissions",

  MAKE_CARD_PAYMENT: "make_card_payment",
  BANK_APPROVE_S: "Bank_Approve_S",
  AML_REVIEW: "AML_Review",
  AML_AUTHORISE: "AML_Authorise",

  LOGOUT_MENU: "logout_menu",
  LOGOUT_QUESTION: "logout_question",

  DASHBOARD: "dashboard",
  KNOWLEDGE_BASE_LINK: "knowledge_base_link",

  INVESTOR_CREATE: "investor_create",
  INVESTORS_DASH: "investors_dash",
  INVESTOR_SESSION: "investor_session",

  COMPANY_CONTROL: "company_control",

  COMMUNICATIONS: "communications",
  NARRATIVE_DEFAULT: "cm_narrative_default",
  RESEND_RECIPIENT_EMAIL: "cm_resend_recipient_email",
  CAMPAIGN_VIEW: "cm_campaign_view",
  CAMPAIGN_EDIT: "cm_campaign_edit",
  COMMUNICATION_VIEW: "cm_communication_view",
  COMMUNICATION_EDIT: "cm_communication_edit",

  SUBMIT_BULK_INSTRUCTION: "submit_bulk_instruction",
  AUTHORISE_BULK_INSTRUCTION: "authorise_bulk_instruction",

  BANK_MAINTAIN: "Bank_Maintain",
  CGT_EFFECT: "CGT_effect",
  EXPORT_VALUATION_CSV: "export_valuation_csv",
  EXPORT_STATEMENT_CSV: "export_statement_csv",
  EXPORT_TRANSACTIONS_CSV: "export_transactions_csv",

  ALLOW_INCOME_CAPITAL_WITHDRAWAL: "ALLOW_INCOME_CAPITAL_WITHDRAWAL",
  ALLOW_PHASED_TRASNFER_IN_CASH: "ALLOW_PHASED_TRASNFER_IN_CASH"
};
